import { effect, inject, Injectable, signal } from "@angular/core";
import { LoginData, UserAuth } from "../model/user-auth";
import { HttpClient } from "@angular/common/http";
import { ApiResponse } from "../model/api-response";
import { InactivityService } from "./inactivity.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

    private http = inject(HttpClient);
    private inactivityService = inject(InactivityService);
    private router = inject(Router);

    private _token = signal<string | null>(localStorage.getItem('access_token'));
    readonly token = this._token.asReadonly();

    constructor() {
        effect(() => {
            const currentToken = this.token();
            
            if (currentToken) {
                console.log('Efecto: Token detectado de forma segura, cargando perfil...');
                this.loadUserProfile();
                this.inactivityService.startWatching(() => {
                    console.log('Inactivity detected, logging out...');
                    this.logout();
                    this.router.navigate(['/login']);
                })
            }
        });
    }

    login(token: string): void {
        localStorage.setItem('access_token', token);
        this._token.set(token);
    }

    logout(): void {
        localStorage.removeItem('access_token');
        this._token.set(null);
        this._userAuth.set(null);
    }

    private _userAuth = signal<UserAuth | null>(null);
    readonly userAuth = this._userAuth.asReadonly();

    setUserAuth(userAuth: UserAuth): void {
        this._userAuth.set(userAuth);
    }


    loadUserProfile(): void {
        if (this.token() === 'mock-token-12345') {
            console.log('Using mock token, skipping profile load from API');
            return;
        }

        this.http.get<ApiResponse<UserAuth>>('/api/v1/auth/me').subscribe({
        next: (response) => {
            this.setUserAuth(response.data);
        },
        error: (error) => {
            console.error('Error loading user profile:', error);
            // this.logout();
        }
        });
    }

    refreshToken(): Observable<LoginData> {
        return this.http.post<LoginData>('/api/v1/auth/refresh', {}, { withCredentials: true });
    }
    
}